export const CHANNEL_DETAILS_REQUEST = 'channeldetails/loading';
export const CHANNEL_DETAILS_SUCCESS = 'channeldetails/success';
export const CHANNEL_DETAILS_FAILED = 'channeldetails/failure';
export const SET_SUBSCRIPTION_STATUS = 'subscriptionstatus/set';